export default __webpack_public_path__ + "static/media/Pano_ER.cd300271.jpg";